import { ClientInvoiceStatus, ContractContactForm, ContractStatus } from '../enums';

export const DEFAULT_CONTRACT_PAYMENT_TERM_DAYS = 15;
export const DEFAULT_CONTRACT_CURRENCY = 'RON';
export const DEFAULT_CONTRACT_INTERVAL_MONTHS = 1;

export const CONTRACT_AMOUNT_MATCH_TOLERANCE = 0.01;
export const CONTRACT_AUTO_LINK_MAX_DAYS = 45;

export const CONTRACT_STATUS_LABELS: Record<ContractStatus, string> = {
  [ContractStatus.NoContract]: 'No contract',
  [ContractStatus.Active]: 'Active',
  [ContractStatus.Overdue]: 'Overdue',
  [ContractStatus.FullyPaid]: 'Fully paid',
  [ContractStatus.Completed]: 'Completed',
  [ContractStatus.Cancelled]: 'Cancelled',
  [ContractStatus.Refunded]: 'Refunded',
};

export const CONTRACT_STATUS_FILTER_OPTIONS = Object.values(ContractStatus).map((value) => ({
  label: CONTRACT_STATUS_LABELS[value],
  value,
}));

export const CONTRACT_STATUS_OPTIONS = Object.values(ContractStatus)
  .filter((value) => value !== ContractStatus.NoContract)
  .map((value) => ({
    label: CONTRACT_STATUS_LABELS[value],
    value,
  }));

export const CLIENT_INVOICE_STATUS_LABELS: Record<ClientInvoiceStatus, string> = {
  [ClientInvoiceStatus.Unpaid]: 'Unpaid',
  [ClientInvoiceStatus.Partial]: 'Partially paid',
  [ClientInvoiceStatus.Overdue]: 'Overdue',
  [ClientInvoiceStatus.Paid]: 'Paid',
  [ClientInvoiceStatus.Cancelled]: 'Cancelled',
};

export const CONTRACT_CONTACT_FORM_LABELS: Record<ContractContactForm, string> = {
  [ContractContactForm.Call]: 'Call',
  [ContractContactForm.Email]: 'Email',
  [ContractContactForm.WhatsApp]: 'WhatsApp',
  [ContractContactForm.Meeting]: 'Meeting',
  [ContractContactForm.Other]: 'Other',
};

export const CONTRACT_CONTACT_FORM_OPTIONS = Object.values(ContractContactForm).map((value) => ({
  label: CONTRACT_CONTACT_FORM_LABELS[value],
  value,
}));
